import { Card, CardBody, Col, Form, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CheckMeOut, EmailLabel, EmailPlaceHolder, FormBasic, PasswordLabel, PasswordPlaceholder, SignInButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import { BASIC_FORM } from "../../../../Data/FormControl/BaseInput";

const BasicForm = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FormBasic} span={BASIC_FORM} />
        <CardBody>
          <div className="card-wrapper border rounded-3">
            <Form className="row g-3" onSubmit={(e)=>e.preventDefault()}>
              <Col md="12">
                <Label check>{EmailLabel}</Label>
                <Input type="email" placeholder={EmailPlaceHolder} />
              </Col>
              <Col ms="12">
                <Label check>{PasswordLabel}</Label>
                <Input type="password" autoComplete="" placeholder={PasswordPlaceholder} />
              </Col>
              <Col sm="12">
                <div className="form-check checkbox-checked">
                  <Input type="checkbox" id="gridCheck1" />
                  <Label htmlFor="gridCheck1" check>{CheckMeOut}</Label>
                </div>
              </Col>
              <Col sm="12"><Btn color="primary" type="submit">{SignInButton}</Btn></Col>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicForm;
